/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Nav_PrivacyInputs */

const en_footer_nav_privacy = /** @type {(inputs: Footer_Nav_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy`)
};

const tr_footer_nav_privacy = /** @type {(inputs: Footer_Nav_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gizlilik`)
};

/**
* | output |
* | --- |
* | "Privacy" |
*
* @param {Footer_Nav_PrivacyInputs} inputs
* @param {{ locale?: "en" | "tr" }} options
* @returns {LocalizedString}
*/
export const footer_nav_privacy = /** @type {((inputs?: Footer_Nav_PrivacyInputs, options?: { locale?: "en" | "tr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Nav_PrivacyInputs, { locale?: "en" | "tr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_footer_nav_privacy(inputs)
	return tr_footer_nav_privacy(inputs)
});